import Joi from 'joi';
import { fieldIsRequired } from '../../../Helper';

export const paymentPlanSchema = (t) =>
  Joi.object({
    paymentPlanName: Joi.string()
      .required()
      .messages({
        'string.empty': fieldIsRequired('payment_plan_name', t),
        'any.required': fieldIsRequired('payment_plan_name', t),
      }),
    paymentTypeId: Joi.number()
      .required()
      .messages({
        'number.base': fieldIsRequired('plan_type', t),
        'any.required': fieldIsRequired('plan_type', t),
      }),
  });
